<template>
  <div>
    <v-layout>
      <div class="title mt-2 primary--text">โควต้าการส่งข้อความบน LINE</div>
      <v-btn class="x-small mt-0" small fab depressed @click="refreshQuota" :loading="loading">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-layout>

    <v-layout wrap>
      <v-flex xs4 class="pa-1" style="border-right: 1px solid rgba(255, 255, 255, 0.5)">
        <div class="caption">จำนวนข้อความทั้งหมด</div>
        <div class="font-weight-bold">
          <v-progress-circular size="18" indeterminate v-if="loading"></v-progress-circular>
          <template v-else>
            {{ quota.quota }}
          </template>
        </div>
      </v-flex>
      <v-flex xs4 class="pa-1" style="border-right: 1px solid rgba(255, 255, 255, 0.5)">
        <div class="caption">จำนวนข้อความส่งแล้ว</div>
        <div class="font-weight-bold">
          <v-progress-circular size="18" indeterminate v-if="loading"></v-progress-circular>
          <template v-else>
            {{ quota.totalUsage }}
          </template>
        </div>
      </v-flex>
      <v-flex xs4 class="pa-1">
        <div class="caption">จำนวนข้อความคงเหลือ</div>
        <div class="font-weight-bold">
          <v-progress-circular size="18" indeterminate v-if="loading"></v-progress-circular>
          <template v-else>
            {{ quota.quotaAvailable }}
          </template>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      quota: {
        quota: 0,
        totalUsage: 0,
        quotaAvailable: 0
      }
    }
  },
  async mounted() {
    await this.refreshQuota()
  },
  methods: {
    async refreshQuota() {
      this.loading = true
      try {
        this.quota = await this.loadData()
      } catch (error) {
        console.error(error)
        this.quota = {
          quota: 'N/A',
          totalUsage: 'N/A',
          quotaAvailable: 'N/A'
        }
      }
      this.loading = false
    },
    async loadData() {
      let response = await this.get(`line/${this.$store.state.livechat.pageid}/check-quota/push`)
      if (response.success) {
        return response.result
      } else {
        return {
          quota: 'N/A',
          totalUsage: 'N/A',
          quotaAvailable: 'N/A'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LineQuota.vue